import { Button } from 'blaze-ui/Button'
import Styles from './TourTooltip.module.scss'
import { forwardRef, ReactNode } from 'react'
import React from 'react'
import { ArrowLeft, ArrowRight, Close } from 'blaze-ui/icons'
import { Tour } from '../Types'

type Props = {
  tour: Tour
  visible?: boolean
  title: string | ReactNode
  content: string | ReactNode
  close: () => void
  steps: {
    currentStep: number
    totalSteps: number
    onBack: () => void
    onNext: () => void
  }
  zIndex?: number
}

export const TourTooltip = forwardRef((props: Props, ref: React.ForwardedRef<HTMLDivElement>) => {
  const { visible = true, tour, title, content, close, steps } = props
  const { currentStep, totalSteps, onBack, onNext } = steps
  const lastStep = currentStep === totalSteps

  return (
    <div
      ref={ref}
      data-product-tour={tour}
      data-product-tour-step={steps.currentStep}
      style={{ visibility: visible ? 'visible' : 'hidden' }}
      className={Styles.root}
    >
      <div className={Styles.header}>
        <div>
          <div className={Styles.stepsCompleted}>
            {currentStep} of {totalSteps}
          </div>
        </div>
        <div className={Styles.close}>
          <Button data-product-tour-close onPress={close} size="xs" variant="tertiary" aria-label="Close">
            <Close size={16} color="#ffffff" />
          </Button>
        </div>
      </div>
      <h3 className={Styles.title}>{title}</h3>
      <p className={Styles.content}>{content}</p>

      <div className={Styles.footer}>
        {steps.currentStep > 1 ? (
          <Button
            data-product-tour-back
            onPress={onBack}
            size="sm"
            variant="tertiary"
            color="var(--light-100)"
            frontIcon={() => <ArrowLeft size={16} />}
          >
            Back
          </Button>
        ) : (
          <div />
        )}

        <div className={Styles.nextButton}>
          <Button
            data-product-tour-next={!lastStep ? true : undefined}
            data-product-tour-finish={lastStep ? true : undefined}
            onPress={onNext}
            size="sm"
            variant="secondary"
            endIcon={lastStep ? undefined : () => <ArrowRight size={16} />}
          >
            {lastStep ? 'Finish' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  )
})
